import * as _ from 'lodash'
import {GeneralLedgerPolicyBO} from "./GeneralLedgerPolicyBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {PASearch} from "../PA.Core/PASearch";


export class GeneralLedgerPolicyBOValidations {

    static Validate(aBO: GeneralLedgerPolicyBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            GeneralLedgerPolicyBOValidations.ValidateExistingEvaluationOrder(aBO)
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if(aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
                        resolve()
                        return
                    }
                    resolve()
                })

                .catch((err) => {
                    error(err)
                })
        })
    }

    static ValidateExistingEvaluationOrder(aBO: GeneralLedgerPolicyBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let selectedEvalOrder: number = aBO.WB_GeneralLedgerPolicy.cif.EVALUATION_ORDER
            PASearch.find(
                'vUI_General_Ledger_Policy_Search',
                {
                    WB_GLRL_ID: {neq: aBO.WB_GeneralLedgerPolicy.cif.WB_GLRL_ID},
                    EVALUATION_ORDER: aBO.WB_GeneralLedgerPolicy.cif.EVALUATION_ORDER
                },
                {
                    WB_GLRL_ID: {type: "number"},
                    EVALUATION_ORDER: {type: "number"}
                },
                [],
                0,
                [])
                .then((arrRows: any[]) => {
                    if (!_.isEmpty(arrRows)) {
                        let arrGeneralLedgerPolicyName: string = _.map(_.sortedUniqBy(arrRows, 'GLRULE_ID'), 'GLRULE_ID').join(', ')
                        ErrorMessage_restate(aBO.ValidateMessageProvider, true, 'SameEvaluationOrderExists', "This evaluation order has been used for "+arrGeneralLedgerPolicyName+", please enter a different evaluation order.")
                        return
                    }
                })
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
}

